import { CheckIcon } from '@heroicons/react/20/solid'
import { Customer } from '../../../../gql/graphql'
import { classNames } from '../../../_helpers'
import { FestivalLogo } from '../../FestivalLogo'

type PropTypes = {
  festival: Customer
  isCurrent: boolean
  onSelect: (festival: Customer) => void
}

export const FestivalOption = ({ festival, isCurrent, onSelect }: PropTypes) => {
  return (
    <button
      type={'button'}
      onClick={() => onSelect(festival)}
      className={classNames(
        'group relative flex w-full items-center justify-between gap-4 rounded-xl border bg-white p-4 text-left cursor-pointer transition-all focus-visible:ring-2 focus-visible:ring-primary-300 focus-visible:ring-offset-2 focus-visible:outline-none',
        isCurrent
          ? 'border-primary-300 bg-primary-500/40 ring-1 ring-primary-300 shadow-sm'
          : 'border-gray-200 shadow-xs hover:border-gray-300 hover:shadow-md'
      )}
    >
      <div className={'flex min-w-0 items-center gap-4'}>
        {festival.logoUrl ? (
          <FestivalLogo
            logoUrl={festival.logoUrl}
            background={festival.logoBackground}
            className={'h-14 w-14 shrink-0 rounded-xl p-1.5 shadow-none ring-1 ring-gray-200'}
          />
        ) : (
          <div className={'flex h-14 w-14 shrink-0 items-center justify-center rounded-xl bg-white text-lg font-semibold text-gray-400 ring-1 ring-gray-200'}>
            {festival.title?.charAt(0)}
          </div>
        )}
        <div className={'flex min-w-0 flex-col gap-0.5'}>
          <div className={'truncate text-base font-semibold text-gray-900'}>
            {festival.title}
          </div>
          {festival.location && (
            <div className={'truncate text-sm text-gray-500'}>
              {festival.location}
            </div>
          )}
        </div>
      </div>
      <div
        className={classNames(
          'flex h-7 w-7 shrink-0 items-center justify-center rounded-full border-2 transition-colors',
          isCurrent ? 'border-primary-300 bg-primary-300' : 'border-gray-300 group-hover:border-gray-400'
        )}
      >
        {isCurrent && (
          <CheckIcon className={'h-4 w-4 text-white'} />
        )}
      </div>
    </button>
  )
}
